import { SurveyInterface } from 'common/types/entities/SurveyInterface'
import { CustomFontProperties } from 'common/utils/fontsUtils'

export function getSurveyFontProperties(entity: SurveyInterface) {
  const fontProperties = entity.fontFamily
    ? [
        {
          fontFamily: entity.fontFamily,
          fontStyle: entity.fontStyle,
          fontWeight: entity.fontWeight,
        },
      ]
    : []

  if (entity.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.mobileFontFamily,
      fontStyle: entity.mobileFontStyle,
      fontWeight: entity.mobileFontWeight,
    })
  }

  return fontProperties
}

export function getSurveyCustomFontProperties(entity: SurveyInterface) {
  const fontProperties: CustomFontProperties[] =
    entity.fontFamily && entity.fontFileId
      ? [
          {
            fontFamily: entity.fontFamily,
            fontFileId: entity.fontFileId,
          },
        ]
      : []

  if (entity.mobileFontFamily && entity.mobileFontFileId) {
    fontProperties.push({
      fontFamily: entity.mobileFontFamily,
      fontFileId: entity.mobileFontFileId,
    })
  }

  return fontProperties
}
